// extracted by mini-css-extract-plugin
module.exports = {"center":"style_center__cJQZC","fullScreen":"style_fullScreen__4ix_5","alignCenter":"style_alignCenter__u9Vue"};